import { defineType } from "sanity";
import { multilingualStringPreview } from "../base/multilingualArrayString";

export default defineType({
  name: "sectionSliderCard",
  type: "object",
  title: "Section Slider Card",
  fields: [
    {
      name: "page",
      type: "reference",
      to: [{ type: "page" }, { type: "landingPage" }, { type: "destination" }]
    },
    {
      name: "image",
      title: "Image",
      description: "overides page card image",
      type: "imageWithAlt",
      options: { hotspot: true }
    },
    {
      name: "title",
      type: "multilingualArrayString",
      description: "overides page card title"
    },
    {
      name: "description",
      type: "multilingualArrayText",
      description: "overides page card description"
    }
  ],
  preview: {
    select: {
      title: "title",
      pageTitle: "page.card.title",
      media: "image"
    },
    prepare({ title, pageTitle, media }) {
      return {
        title:
          multilingualStringPreview(title) ||
          multilingualStringPreview(pageTitle),
        media
      };
    }
  }
});
